/**
 * Bo+Tee footer (OHP001P-44)
 * Desktop (990px+): link columns stay expanded.
 * Mobile: independent accordions, collapsed by default.
 */
const FOOTER_DESKTOP = window.matchMedia('(min-width: 990px)');

function footerNavColumns() {
  return document.querySelectorAll('.bt-footer__nav-col');
}

function syncFooterNav(mql) {
  footerNavColumns().forEach((details) => {
    details.open = mql.matches;
  });
}

function preventDesktopToggle(event) {
  if (FOOTER_DESKTOP.matches) event.preventDefault();
}

function bindFooterNav() {
  footerNavColumns().forEach((details) => {
    const summary = details.querySelector('.bt-footer__nav-summary');
    if (summary) summary.addEventListener('click', preventDesktopToggle);
  });
  syncFooterNav(FOOTER_DESKTOP);
}

bindFooterNav();
FOOTER_DESKTOP.addEventListener('change', () => syncFooterNav(FOOTER_DESKTOP));

function newsletterRoot(from) {
  return from?.closest?.('#FooterNewsletter');
}

function subscribeNewsletter(root) {
  if (!root) return;

  const input = root.querySelector('.bt-newsletter-field__input');
  const submit = root.querySelector('.bt-newsletter-field__submit');
  const success = root.querySelector('#FooterNewsletterSuccess');
  const email = input?.value.trim() ?? '';

  if (!email) {
    input?.reportValidity?.();
    return;
  }

  if (input && !input.checkValidity()) {
    input.reportValidity();
    return;
  }

  // Future: replace this stub with the newsletter HTTP call.
  // await fetch(endpoint, { method: 'POST', body: JSON.stringify({ email }) });

  success?.removeAttribute('hidden');
  input?.setAttribute('aria-describedby', 'FooterNewsletterSuccess');
  if (submit) submit.disabled = true;
}

document.addEventListener('click', (event) => {
  const submit = event.target.closest('#FooterNewsletter .bt-newsletter-field__submit');
  if (!submit) return;
  event.preventDefault();
  subscribeNewsletter(newsletterRoot(submit));
});

document.addEventListener('keydown', (event) => {
  if (event.key !== 'Enter') return;
  const input = event.target.closest('#FooterNewsletter .bt-newsletter-field__input');
  if (!input) return;
  event.preventDefault();
  subscribeNewsletter(newsletterRoot(input));
});
